export default "__VITE_ASSET__0MyP9ZaP__"